import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { ReactSVG } from "react-svg";
import clsx from "clsx";
import { getDiscountPrice } from "../../helpers/product";
import Breadcrumb from "../../components/Breadcrumb/Breadcrumb";

type Props = {}

const Checkout = (props: Props) => {
    let cartTotalPrice = 0;
    const { cartItems } = useSelector((state:any) => state.cart);
    return (
        <div className={clsx("body-wrapper", cartItems && cartItems.length >= 1 && "bg-color--gradient", "space-pt--70 space-pb--120")} >
            <Breadcrumb pageTitle="Checkout" prevUrl="/" />
            {cartItems && cartItems.length >= 1 ? (
                <div className="checkout-body space-mt--30">
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <div className="checkout-form">
                                <form>
                                    <div className="your-order-area space-mb--30">
                                        <h3>Your order</h3>
                                        <div className="your-order-wrap gray-bg-4">
                                            <div className="your-order-product-info">
                                            <div className="your-order-top">
                                                <ul>
                                                <li>Product</li>
                                                <li>Total</li>
                                                </ul>
                                            </div>
                                            <div className="your-order-middle">
                                                <ul>
                                                {cartItems.map((cartItem:any, key:any) => {
                                                    const discountedPrice = getDiscountPrice( cartItem.price, cartItem.discount );
                                                    discountedPrice != null ? (cartTotalPrice += discountedPrice * cartItem.quantity) : (cartTotalPrice += cartItem.price * cartItem.quantity);
                                                    return (
                                                        <li key={key}>
                                                            <span className="order-middle-left">
                                                            {cartItem.name} X {cartItem.quantity}
                                                            </span>{" "}
                                                            <span className="order-price">
                                                            {discountedPrice !== null
                                                                ? "$" +
                                                                (
                                                                    discountedPrice * cartItem.quantity
                                                                ).toFixed(2)
                                                                : "$" +
                                                                (
                                                                    cartItem.price * cartItem.quantity
                                                                ).toFixed(2)}
                                                            </span>
                                                        </li>
                                                    );
                                                })}
                                                </ul>
                                            </div>
                                            <div className="your-order-total">
                                                <ul>
                                                <li className="order-total">Total</li>
                                                <li>${cartTotalPrice.toFixed(2)}</li>
                                                </ul>
                                            </div>
                                            </div>
                                        </div>
                                    </div>
                                    <button className="checkout-form__button"> Place Order </button>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
                </div>
            ) : (
                <div className="no-items-found">
                <div className="no-items-found__image">
                    <ReactSVG
                    src={process.env.PUBLIC_URL + "/assets/img/icons/money.svg"}
                    />
                </div>
                <div className="no-items-found__content">
                    <p>
                    No Items in the cart to checkout.{" "}
                    <Link to={process.env.PUBLIC_URL + "/"}>Add Some</Link>
                    </p>
                </div>
                </div>
            )}
            </div>
    )
}

export default Checkout